import React, { useRef, useState } from 'react';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { Box, Link, styled, Typography } from '@mui/material';
import { Checkbox, CheckboxProps } from 'components';

const StyledIframe = styled('iframe')(({ theme }) => ({
  width: '100%',
  border: 'none',
}));

type PrivacyPolicyCheckboxProps = Omit<CheckboxProps, 'label'>;

interface PrivacyPolicyProps {
  title: string;
  privacyPolicyUrl: string;
  eulaPolicyUrl: string;
  privacyPolicyAcceptanceStateFieldProps: PrivacyPolicyCheckboxProps;
  eulaPolicyAcceptanceStateFieldProps: PrivacyPolicyCheckboxProps;
}

export const PrivacyPolicy = ({
  title,
  privacyPolicyUrl,
  eulaPolicyUrl,
  privacyPolicyAcceptanceStateFieldProps,
  eulaPolicyAcceptanceStateFieldProps,
}: PrivacyPolicyProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { translation } = useTranslationContext();
  const [height, setHeight] = useState('800px');

  const handleLoad = () => {
    const iframe = iframeRef.current;
    if (iframe?.contentDocument?.body) {
      const newHeight = `${iframe.contentDocument.body.scrollHeight}px`;
      setHeight(newHeight);
    }
  };

  return (
    <Box>
      <Typography variant="h5" color="primary">
        {title}
      </Typography>
      <StyledIframe
        ref={iframeRef}
        src={privacyPolicyUrl}
        style={{ height }}
        title="Privacy Policy"
        onLoad={handleLoad}
      />
      <Checkbox
        label={translation('privacy_policy_confirmation')}
        checked={Boolean(privacyPolicyAcceptanceStateFieldProps.value)}
        {...privacyPolicyAcceptanceStateFieldProps}
      />
      <Typography variant="h4" fontWeight={600} mt={6} mb={2}>
        {translation('eula_title')}
      </Typography>
      <Typography variant="body1" color="grey.800" mb={4}>
        {translation('information_about_our')}{' '}
        <Link href={eulaPolicyUrl} target="_blank" rel="noopener noreferrer" fontWeight={600}>
          {translation('eula')}
        </Link>
      </Typography>
      <Checkbox
        label={translation('eula_confirmation')}
        checked={Boolean(eulaPolicyAcceptanceStateFieldProps.value)}
        {...eulaPolicyAcceptanceStateFieldProps}
      />
    </Box>
  );
};
